import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVeoAiVideoGeneratorConfig } from '@/data/landingConfig/landingVeoAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VeoAiVideoGenerator } from './schemaObject';

interface Props {}
const VeoAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VeoAiVideoGenerator} />
			<LandingTemplate
				data={landingVeoAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default VeoAiVideoGenerator;
